module.exports = __webpack_public_path__ + "static/media/Logo4.aef3206e.png";